import React, { memo } from 'react';
import styled from 'styled-components';

import { translate } from '../../../common/translation/translate';
import { AqiHealthAdviceAndTopTriggersType } from './types';

interface AqiHealthAdvicesTopTriggerHeaderProps {
    title: keyof typeof AqiHealthAdviceAndTopTriggersType;
}

export const AqiHealthAdvicesTopTriggerHeader = memo(({ title }: AqiHealthAdvicesTopTriggerHeaderProps) => {
    return (
        <Container>{translate(title)}</Container>
    );
});

AqiHealthAdvicesTopTriggerHeader.displayName = 'AqiHealthAdvicesTopTriggerHeader';

const Container = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    padding: 6px 10px;

    width: 100%;
    height: 36px;

    background: #FFFFFF;
    border-radius: 2px 2px 0px 0px;

    font-family: Source Sans Pro;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: #555555;

    letter-spacing: 0.25px;
    text-transform: uppercase;
    border-bottom: 1px solid #EEEEEE;
`;
